import React from "react";
import "./Navbar.css";
import { NavLink } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css"; 

AOS.init({
  duration: 1000, 
  easing: "ease-in-out", 
});

const Activities = (props) => {
  return (
    <div>
      <div class="">
      <div className="typewriter-text2 text-center "><h1 className="">{props.pageName}</h1></div>
        </div>
      <div class="container">
        {/* <div data-aos="fade-up"> */}

        <div className="col-sm">
        {" "}
          {/* Each activity will take full width on small screens */}
          <div className="activity activity1 card11" data-aos="fade-right"
        data-aos-anchor-placement="top-center">
            <div className="content-box box-left">
              <h1>Health</h1>
              <div className="underline"></div>
              <div className="btn-grp">
                <button className="btn">
                  <NavLink to="/activity/HEALTH" style={{ textDecoration: 'none',color:'white' }}> View Details{" "}</NavLink>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-right-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        {/* </div> */}

        </div>
        
        <div className="col-sm">
          <div className="activity activity2" data-aos="fade-left"
        data-aos-anchor-placement="top-center" >
            <div className="content-box box-right">
              <h1>Education</h1>
              <div className="underline"></div>
              <div className="btn-grp">
                <button className="btn">
                <NavLink to="/activity/EDUCATION" style={{ textDecoration: 'none',color:'white' }}> View Details{" "}</NavLink>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-right-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm">
          <div className="activity activity3" data-aos="fade-right"
        data-aos-anchor-placement="top-center">
            <div className="content-box box-left">
              <h1>Society</h1>
              <div className="underline"></div>
              <div className="btn-grp">
                <button className="btn">
                  {/* View Details{" "} */}
                  <NavLink to="/activity/SOCIETY" style={{ textDecoration: 'none',color:'white' }}> View Details{" "}</NavLink>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-right-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm">
          <div className="activity activity4" data-aos="fade-left"
        data-aos-anchor-placement="top-center">
            <div className="content-box box-left">
              <h1>Environment</h1>
              <div className="underline"></div>
              <div className="btn-grp">
                <button className="btn">
                <NavLink to="/activity/ENVIRONMENT" style={{ textDecoration: 'none',color:'white' }}> View Details{" "}</NavLink>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-right-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm">
          <div class="activity activity5" data-aos="fade-right"
        data-aos-anchor-placement="top-center">
            <div class="content-box box-left">
              <h1>Innovation</h1>
              <div class="underline"></div>
              <div className="btn-grp">
                <button className="btn">
                <NavLink to="/activity/INNOVATION" style={{ textDecoration: 'none',color:'white' }}> View Details{" "}</NavLink>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-right-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Activities;
